import { useEffect, useRef } from "react";
import { ArrowDown } from "lucide-react";
import { scrollToId } from "../../hooks/useLenisScroll";

const LINE1 = "THE STARS WROTE YOUR STORY.";
const LINE2 = "LET'S READ IT.";

const renderAnimatedLine = (text, lineKey) =>
  text.split(" ").map((word, wi) => (
    <span key={`${lineKey}-${wi}`} className="inline-block whitespace-nowrap mr-[0.25em]">
      {word.split("").map((ch, ci) => (
        <span key={ci} className="hero-letter inline-block">
          {ch}
        </span>
      ))}
    </span>
  ));

export const Hero = () => {
  const headlineRef = useRef(null);

  useEffect(() => {
    if (!window.gsap || !headlineRef.current) return;
    const letters = headlineRef.current.querySelectorAll(".hero-letter");
    window.gsap.fromTo(
      letters,
      { opacity: 0, filter: "blur(14px)", y: 16 },
      { opacity: 1, filter: "blur(0px)", y: 0, duration: 0.7, ease: "power2.out", stagger: 0.028, delay: 0.5 }
    );
  }, []);

  return (
    <section id="hero" className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-32 pb-20 text-center overflow-x-clip">
      <div className="glow-dot w-[520px] h-[520px] bg-[#A99BFF]/20 -top-40 -left-32" />
      <div className="glow-dot w-[420px] h-[420px] bg-[#E8C27A]/15 bottom-0 right-0" />

      <p className="reveal cosmic-eyebrow text-sm md:text-base mb-6 relative z-10">Astrology &amp; Tarot by Cosmic Code</p>

      <h1
        ref={headlineRef}
        data-testid="hero-headline"
        className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.15] max-w-4xl gold-text relative z-10"
      >
        {renderAnimatedLine(LINE1, "l1")}
        <br />
        {renderAnimatedLine(LINE2, "l2")}
      </h1>

      <p className="reveal text-scrim font-accent italic text-lg md:text-xl text-[#F3EEE4] max-w-xl mt-7 relative z-10">
        A private birth chart reading &amp; tarot session that turns the sky's quiet language into clear direction — for your purpose, your love life, and your next move.
      </p>

      <div className="reveal flex flex-col sm:flex-row gap-4 mt-10 relative z-10">
        <a data-testid="hero-book-reading-button" href="#" className="btn-gold">
          <span className="btn-content">Book a Reading</span>
        </a>
        <button data-testid="hero-find-sign-button" onClick={() => scrollToId("zodiac")} className="btn-ghost">
          <span className="btn-content">Find My Sign</span>
        </button>
      </div>

      <div data-testid="hero-moon-placeholder" className="reveal w-full max-w-[420px] h-[320px] mx-auto mt-16 relative z-10" />

      <button
        data-testid="hero-scroll-indicator"
        onClick={() => scrollToId("intro")}
        className="reveal absolute bottom-8 text-[#E8C27A]/60 animate-bounce"
        aria-label="Scroll down"
      >
        <ArrowDown size={22} />
      </button>
    </section>
  );
};
